import React from "react";

const TaskFollowupActionIcon = (props) => (
    <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="40" height="40" rx="20" />
        <path
            d="M4.58824 1.72059L5.55882 0.75H7.5H9.44118L10.4118 1.72059M4.58824 1.72059V3.17647H10.4118V1.72059M4.58824 1.72059H10.4118M4.58824 1.72059H1.19118V13.3676M10.4118 1.72059H13.8088V17.25H6.04412M6.04412 17.25L1.19118 13.3676M6.04412 17.25V13.3676H1.19118M5 8.5H10M10 8.5L8.5 7M10 8.5L8.5 10"
            stroke={props.color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default TaskFollowupActionIcon;
